import { createContext, useState, useContext, useMemo } from 'react';

const RelatoriosGerenciaisContext = createContext();

export const useRelatoriosGerenciaisContext = () => useContext(RelatoriosGerenciaisContext);

export const RelatoriosGerenciaisProvider = ({ children }) => {
    //Identificador geral
    const [tipoInscricaoSolicitante, setTipoInscricaoSolicitante] = useState(1);
    const [numeroInscricaoSolicitante, setNumeroInscricaoSolicitante] = useState('');
    const [tipoInscricaoEmpregador, setTipoInscricaoEmpregador] = useState(1);
    const [numeroInscricaoEmpregador, setNumeroInscricaoEmpregador] = useState('');
    const [tipoRelatorio, setTipoRelatorio] = useState('');
    const [opcoesTipoRelatorio, setOpcoesTipoRelatorio] = useState([{ value: '', label: 'Não carregado' }]);

    //Filtros
    const [semFiltros, setSemFiltros] = useState(true);

    const [incluiTrabalhadoresAtivos, setIncluiTrabalhadoresAtivos] = useState(false);
    const [incluiTrabalhadoresPCD, setIncluiTrabalhadoresPCD] = useState(false);

    const [desconsiderarAnotacoesJudiciais, setDesconsiderarAnotacoesJudiciais] = useState(false);

    const [cpfTrabalhador, setCpfTrabalhador] = useState('');

    const [categorias, setCategorias] = useState([]);
    const [opcoesCategorias, setOpcoesCategorias] = useState([{ value: 0, label: 'Não carregado' }]);
    const [cbo, setCbo] = useState([]);
    const [opcoesCBO, setOpcoesCBO] = useState([{ value: 0, label: 'Não carregado' }]);

    const [tipoEstabelecimento, setTipoEstabelecimento] = useState('');
    const [opcoesTipoEstabelecimento, setOpcoesTipoEstabelecimento] = useState([{ value: '', label: 'Não carregado' }]);
    const [estabelecimentos, setEstabelecimentos] = useState('');

    const [periodoAdmissaoInicio, setPeriodoAdmissaoInicio] = useState('');
    const [periodoAdmissaoFim, setPeriodoAdmissaoFim] = useState('');
    const [periodoDesligamentoInicio, setPeriodoDesligamentoInicio] = useState('');
    const [periodoDesligamentoFim, setPeriodoDesligamentoFim] = useState('');

    //Relatorios do usuario
    const [relatoriosSolicitados, setRelatoriosSolicitados] = useState([]);

    //Tela de Validação
    const [tipoInscricaoEmpregadorVal, setTipoInscricaoEmpregadorVal] = useState('');
    const [numeroInscricaoEmpregadorVal, setNumeroInscricaoEmpregadorVal] = useState('');
    const [chaveValidacao, setChaveValidacao] = useState('');
    const [dataSolicitacaoRelatorio, setDataSolicitacaoRelatorio] = useState('');
    const [relatorioVal, setRelatorioVal] = useState();


    //Formatadores
    const formatFiltro = (filtro) => {
        const labels = {
            trabalhadoresAtivos: 'Trabalhadores Ativos',
            trabalhadoresPcd: 'Trabalhadores PCD',
            desconsiderarAnotacoesJudiciais: 'Desconsiderar Anotações Judiciais',
            cpfTrabalhador: 'CPF Trabalhador',
            categorias: 'Categorias',
            cbo: 'CBO',
            lotacaoTributaria: 'Lotação Tributária',
            tipoEstabelecimento: 'Tipo Estabelecimento',
            estabelecimentos: 'Estabelecimentos',
            admissaoInicio: 'Admissão Início',
            admissaoFim: 'Admissão Fim',
            desligamentoInicio: 'Desligamento Início',
            desligamentoFim: 'Desligamento Fim',
        };

        const filteredEntries = Object.entries(JSON.parse(filtro))
            .filter(([_, value]) => value !== null) // Filter out null values

        return (
            <ul style={{ padding: 0, listStyleType: 'none', marginTop: 0, marginBottom: 0 }}>
                {filteredEntries.length == 0 ?
                <li>Todos os vínculos do eSocial</li> :
                filteredEntries.map(([key, value]) => (
                    <li
                        key={key}
                        style={{
                            wordWrap: 'break-word',
                            whiteSpace: 'normal',
                        }}
                    >
                        {typeof value === 'boolean'
                            ? labels[key]
                            : `${labels[key]}: ${value}`}
                    </li>
                ))}
            </ul>
        );
    }

    const formatDate = (isoString) => {
        // Extract the relevant portion of the string
        const match = isoString.match(/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/);
        const trimmedIsoString = match ? match[0] : isoString.split("T")[0]; // Default to just the date if no match

        let date;
        let isDateTime = trimmedIsoString.includes("T");
        if (isDateTime) {
            // Handle datetime strings like YYYY-MM-DDTHH:MM:SS
            const [datePart, timePart] = trimmedIsoString.split("T");
            const [year, month, day] = datePart.split("-").map(Number);
            const [hours, minutes, seconds] = timePart.split(":").map(Number);
            date = new Date(Date.UTC(year, month - 1, day, hours, minutes, seconds));
        } else {
            // Handle date-only strings like YYYY-MM-DD
            const [year, month, day] = trimmedIsoString.split("-").map(Number);
            date = new Date(Date.UTC(year, month - 1, day));
        }

        // Format the date
        const day = String(date.getUTCDate()).padStart(2, '0');
        const month = String(date.getUTCMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = date.getUTCFullYear();
        const hours = String(date.getUTCHours()).padStart(2, '0');
        const minutes = String(date.getUTCMinutes()).padStart(2, '0');
        const seconds = String(date.getUTCSeconds()).padStart(2, '0');

        return isDateTime ? `${day}/${month}/${year} ${hours}:${minutes}:${seconds}` : `${day}/${month}/${year}`;
    };

    const formatDisponivelAte = (date, situacao) => {
        if (date == null || situacao != 2) {
            return '-';
        }
        else {
            let newDate = new Date(date);
            newDate.setDate(newDate.getDate() + 30);
            const day = String(newDate.getDate()).padStart(2, '0');
            const month = String(newDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const year = newDate.getFullYear();
            return `${day}/${month}/${year}`;
        }
    }

    //Constantes
    const opcoesTipoInscricao = [
        { value: 2, label: 'CPF' },
        { value: 1, label: 'CNPJ' }
    ];
    const [descricaoSituacao, setDescricaoSituacao] = useState([]);

    const value = useMemo(() => ({
        tipoInscricaoSolicitante, setTipoInscricaoSolicitante,
        numeroInscricaoSolicitante, setNumeroInscricaoSolicitante,
        tipoInscricaoEmpregador, setTipoInscricaoEmpregador,
        numeroInscricaoEmpregador, setNumeroInscricaoEmpregador,
        tipoRelatorio, setTipoRelatorio,
        semFiltros, setSemFiltros,
        opcoesTipoRelatorio, setOpcoesTipoRelatorio,
        incluiTrabalhadoresAtivos, setIncluiTrabalhadoresAtivos,
        incluiTrabalhadoresPCD, setIncluiTrabalhadoresPCD,
        desconsiderarAnotacoesJudiciais, setDesconsiderarAnotacoesJudiciais,
        cpfTrabalhador, setCpfTrabalhador,
        categorias, setCategorias, opcoesCategorias, setOpcoesCategorias,
        cbo, setCbo, opcoesCBO, setOpcoesCBO,
        tipoEstabelecimento, setTipoEstabelecimento, opcoesTipoEstabelecimento, setOpcoesTipoEstabelecimento,
        estabelecimentos, setEstabelecimentos,
        periodoAdmissaoInicio, setPeriodoAdmissaoInicio,
        periodoAdmissaoFim, setPeriodoAdmissaoFim,
        periodoDesligamentoInicio, setPeriodoDesligamentoInicio,
        periodoDesligamentoFim, setPeriodoDesligamentoFim,
        relatoriosSolicitados, setRelatoriosSolicitados,
        tipoInscricaoEmpregadorVal, setTipoInscricaoEmpregadorVal,
        numeroInscricaoEmpregadorVal, setNumeroInscricaoEmpregadorVal,
        chaveValidacao, setChaveValidacao,
        dataSolicitacaoRelatorio, setDataSolicitacaoRelatorio,
        relatorioVal, setRelatorioVal,
        formatFiltro, formatDate, formatDisponivelAte,
        opcoesTipoInscricao,
        descricaoSituacao, setDescricaoSituacao,
    }),[tipoInscricaoSolicitante, numeroInscricaoSolicitante, tipoInscricaoEmpregador, tipoRelatorio, numeroInscricaoEmpregador, opcoesTipoRelatorio, incluiTrabalhadoresAtivos, incluiTrabalhadoresPCD,
        desconsiderarAnotacoesJudiciais, cpfTrabalhador, categorias, opcoesCategorias, cbo, opcoesCBO,
        tipoEstabelecimento, estabelecimentos, opcoesTipoEstabelecimento, semFiltros,
        periodoAdmissaoInicio, periodoAdmissaoFim, periodoDesligamentoInicio, periodoDesligamentoFim, relatoriosSolicitados,
        tipoInscricaoEmpregadorVal, numeroInscricaoEmpregadorVal, chaveValidacao, dataSolicitacaoRelatorio, relatorioVal, descricaoSituacao,
    ]);

    return (
        <RelatoriosGerenciaisContext.Provider value={value}>
            {children}
        </RelatoriosGerenciaisContext.Provider>
    );
};
